module.exports = __webpack_public_path__ + "static/media/PortfolioCover.c025eed3.png";